import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetOrganizations } from '@/hooks/useGetOrganizations';
import * as S from './styles';

interface OrganizationFormItemProps {
	disabled?: boolean;
}

export function OrganizationFormItem({ disabled = false }: OrganizationFormItemProps) {
	const form = Form.useFormInstance();
	const { data: organizations = [], isFetching } = useGetOrganizations();

	function handleOnChange(): void {
		form.setFieldValue('company_id', undefined);
		form.setFieldValue('sector_id', undefined);
		form.setFieldValue('line_id', undefined);
		form.setFieldValue('workstation_id', undefined);
	}

	return (
		<S.CustomFormItem name="organization_id" label={I18n.get('Company')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				disabled={disabled}
				loading={isFetching}
				options={organizations}
				onChange={disabled ? undefined : handleOnChange}
				placeholder={I18n.get('Company')}
			/>
		</S.CustomFormItem>
	);
}
